/* eslint-disable react-refresh/only-export-components */
import { withSuspense } from '@/modules/global-components/ui/suspense/withSuspense';
import { lazy } from 'react';

const ListCustomerInvoices = lazy(
  () => import('@/modules/accounting/invoices/list/ListCustomerInvoices'),
);

const ViewInvoiceData = lazy(
  () => import('@/modules/accounting/invoices/view/ViewInvoiceData'),
);

const ListPayments = lazy(
  () => import('@/modules/accounting/payments/list/ListPayments'),
);

const ViewPayment = lazy(
  () => import('@/modules/accounting/payments/view/ViewPayment'),
);

const ListCarriers = lazy(
  () => import('@/modules/main/carrier/list/ListCarrier'),
);

const ViewCarrier = lazy(
  () => import('@/modules/main/carrier/view/ViewCarrier'),
);

const CustomerAccounts = lazy(
  () =>
    import('@/modules/main/customer/view/components/tabs/accounts/CustomerAccounts'),
);

const Dashboard = lazy(() => import('@/modules/main/dashboard/Dashboard'));

export const customerRoutes = [
  {
    path: ':code',
    children: [
      {
        path: 'dashboard',
        element: withSuspense(Dashboard),
      },
      {
        path: 'carriers',
        children: [
          {
            path: 'list',
            element: withSuspense(ListCarriers),
          },
          {
            path: ':carrier_guid/view',
            element: withSuspense(ViewCarrier),
          },
        ],
      },
      {
        path: 'invoice',
        children: [
          {
            path: 'list',
            element: withSuspense(ListCustomerInvoices),
          },
          {
            path: ':id/view',
            element: withSuspense(ViewInvoiceData),
          },
        ],
      },
      {
        path: 'payments',
        children: [
          {
            path: 'list',
            element: withSuspense(ListPayments),
          },
          {
            path: ':id/view',
            element: withSuspense(ViewPayment),
          },
        ],
      },
      {
        path: 'transaction',
        element: withSuspense(CustomerAccounts),
      },
    ],
  },
];
